import Button from "../../components/Button";

import { Button as ButtonPrime } from "primereact/button";

import { useResultScreen } from "./useResultScreen";
import styles from "./styles.module.css";
import { formatAneelUc } from "../../shared/utils/newUcMask";

export function ResultScreen() {
  const hook = useResultScreen();
  return (
    <div className="flex flex-column w-4 m-auto gap-8">
      <div className="flex flex-column ">
        {!hook.response?.consultaUcResponse?.ucAntiga &&
        !hook.response?.consultaUcResponse?.ucANEEL ? (
          <p className="text-primary font-bold mb-4">
            {hook.response?.consultaUcResponse?.mensagemDeRetorno ||
              "Nenhuma unidade consumidora encontrada."}
          </p>
        ) : (
          <>
            <div className="flex w-full justify-content-between border-bottom-1 pb-4 border-300">
              <p>
                <span className="font-bold text-gray-600">
                  Unidade consumidora:{" "}
                </span>{" "}
                {hook.response?.consultaUcResponse?.ucAntiga}
              </p>
              <ButtonPrime
                icon="pi pi-clone"
                rounded
                text
                raised
                severity="help"
                aria-label="copy"
                className={styles.btnIcon}
                tooltip="Copiar unidade consumidora"
                tooltipOptions={{ position: "bottom" }}
                onClick={() =>
                  hook.copy(
                    hook.response?.consultaUcResponse?.ucAntiga?.toString() ||
                      ""
                  )
                }
              />
            </div>

            <hr />

            <div className="flex w-full justify-content-between">
              <p>
                <span className="font-bold text-gray-600">
                  Novo número:{" "}
                </span>{" "}
                {formatAneelUc(hook.response?.consultaUcResponse?.ucANEEL)}
              </p>
              <ButtonPrime
                icon="pi pi-clone"
                rounded
                text
                raised
                severity="help"
                aria-label="copy"
                className={styles.btnIcon}
                tooltip="Copiar novo número"
                tooltipOptions={{ position: "bottom" }}
                onClick={() => hook.copy(hook.response?.consultaUcResponse?.ucANEEL?.toString() || "")}
              />
            </div>
          </>
        )}
      </div>

      <div className="flex justify-content-end">
        <Button
          label="Nova pesquisa"
          type="button"
          onClick={hook.handleNewSearchBtn}
          secondary
        />
      </div>
    </div>
  );
}
